<template>
  <div id="app" :class="theme">
    <router-view name="header" />
    <div class="wrapper">
      <router-view />
    </div>
    <router-view name="footer" />
    <div id="backtotop">
      <a href="#" />
    </div>
  </div>
</template>

<script>
import { useCoreStore } from '@/stores/core.js'

export default {
  name: 'App',
  setup () {
    const coreStore = useCoreStore()
    return { coreStore }
  },
  computed: {
    theme: function () {
      if (this.coreStore.conf) {
        return this.coreStore.setting('theme', 'UI_THEME').value
      } else {
        return 'labos1point5'
      }
    }
  }
}
</script>

<style lang="scss">
@import './assets/scss/core.scss';
@import './assets/themes/labos1point5/main.scss';
@import './assets/themes/framasoft/main.scss';
@import './assets/themes/campus/main.scss';
</style>

<style lang="css">
@import './assets/css/icons.css';
html {
  scroll-behavior: smooth;
}
body {
  font-family: 'Ubuntu', sans-serif;
}
.boxicon {
  padding: 50px 20px 10px 20px;
  height: 100%;
  margin-bottom: 20px;
  text-align: center;
  border: 1px solid #e6e6e6;
  border-radius: 4px;
  position: relative;
  background: #fafafa;
}
.boxicon-home {
  border-radius: 10px;
  border: none;
  background-color: #fff;
  box-shadow: 0 2px 29px 0 rgba(68, 88, 144, 0.12);
  height: auto;
}
.boxicon .bicon .notlink {
  cursor: default;
}
.boxicon > .bicon {
  position: absolute;
  top: -36px;
  left: calc(50% - 36px);
  transition: 0.2s;
  border-radius: 50%;
  display: inline-block;
  border: 6px solid #fff;
}
.boxicon > .bicon > a > span > i {
  font-size: 28px;
  color: #fff;
}
.boxicon > .bicon > a {
  display: inline-block;
  background: rgba(52, 59, 64, 1);
  border: 2px solid rgba(52, 59, 64, 1);
  padding: 16px;
  border-radius: 50%;
  transition: 0.3s;
  width: 62px;
  height: 62px;
  color: #fff;
}
.boxicon > h4 {
  font-weight: 700;
  font-size: 1.25em;
  text-transform: uppercase;
  letter-spacing: 3px;
  margin-top: 0px;
  margin-bottom: 10px;
}
.boxicon > p {
  color: #555;
}
.modal-card,
.modal-card-body {
  overflow: auto !important;
}
.tabs li.is-active a {
  color: #4680df !important;
  border-bottom-color: #4680df !important;
}
ul {
  margin-bottom: 5px !important;
}
div.tooltip {
  height: 0px !important;
  padding: 0px !important;
}
article {
  color: #555 !important;
  text-align: justify;
  padding-right: 1.5rem !important;
}
#nprogress .bar {
  background: #ffffff !important;
}
#nprogress .peg {
  box-shadow: 0 0 10px #ffffff, 0 0 5px #ffffff;
}
#nprogress .spinner-icon {
  border-top-color: #ffffff;
  border-left-color: #ffffff;
}
.menu-list a.is-active {
  background-color: rgba(52, 59, 64, 0.7) !important;
  color: white;
}
</style>
